import styled from '@emotion/styled/macro';

import { ButtonsContainer } from '../../../../components/ModalCommon/ModalCommon';

export const StyledButtonsContainer = styled(ButtonsContainer)`
  margin-top: 0;
`;
